import { environment as env } from '@/env/environment';

export const getLanguage = () => {
    const paths = window.location.href.split('/');
    const language = paths.find((path) => env.allowedLanguages.includes(path));
    return language ?? 'es-mx';
};
